var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('layout-navbar'),_c('div',{staticClass:"menu"},[(_vm.showNavbar)?_c('menus'):_vm._e()],1),_c('div',{staticClass:"body"},[_c('base-spinner'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }